$(document).ready(() => {
  $(document).on('select2:select', '.select2_input_filter', (event) => {
    const selectField = $(event.currentTarget);
    const optionSelected = selectField.find('option:selected');
    const newOptionVal = optionSelected.val();
    const newOptionId = `${selectField.data('new-option-id')}_${newOptionVal}`;
    if (!$(`#${newOptionId}`).length) {
      const fieldTarget = $(`.${selectField.data('field-target-class')}`);
      const groupElement = $(`#${selectField.data('field-target-class')} ol.choices-group`);
      const newOptionName = selectField.data('new-option-name');
      const newOptionText = optionSelected.text();
      const newLiElement = $('<li></li>').addClass('choice');
      const newLabelElement = $('<label></label>').attr({
        for: newOptionId,
      });
      newLabelElement.text(newOptionText);
      const newInputElement = $('<input></input>').attr({
        id: newOptionId,
        type: 'checkbox',
        name: newOptionName,
        value: newOptionVal,
      });
      newInputElement.addClass(fieldTarget);
      groupElement.append(newLiElement.append(newLabelElement.prepend(newInputElement)));
    }
  });
});
